jQuery(window).on('load', function() {
	TweenMax.to(jQuery('.preloader'), .5, {
		opacity: 0,
		display: 'none'
	});
});

jQuery( document ).ready(function( $ ) {

	$(document).ready(function() {
		$('.navbar-toggle, .navbar-overlay').on('click', function(){
			$('.navbar-overlay, .navbar-sidemenu').toggleClass('active');
		});

		$('.carousel').slick({
			prevArrow:'<button type="button" class="slick-prev"><span class="glyphicon glyphicon-chevron-left"></span></button>',
			nextArrow:'<button type="button" class="slick-next"><span class="glyphicon glyphicon-chevron-right"></span></button>'
		});

		$('.carousel-interviews').slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			dots: true,
			prevArrow:'<button type="button" class="slick-prev"><span class="glyphicon glyphicon-chevron-left"></span></button>',
			nextArrow:'<button type="button" class="slick-next"><span class="glyphicon glyphicon-chevron-right"></span></button>',
			responsive: [{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			  }
			}]
		});

		$('.page-template-page-culture .section-life-item').on('click', function(){
			$('#videoCarousel').html('<iframe width="640" height="360" src="'+$(this).data('video')+'&autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>')
			$('html,body').animate({scrollTop:$('#videoCarousel').offset().top-$('.navbar-default').outerHeight()});
			$('.section-life-item.active').removeClass('active');
			$(this).addClass('active');
		});
		
		$('#home-video').on('click', function(){
			var _video = $(this).data('video');
			$('.section-home').removeAttr('style').addClass('section-home-video').animate({height:$('.section-home').width()*0.5625}, 400, function(){
				$('.section-home').html('<div class="videocontainer"><iframe width="640" height="360" src="'+_video+'&autoplay=1&rel=0&modestbranding=1&showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>').removeAttr('style');
			});
				//.html('<div class="videocontainer"><iframe width="640" height="360" src="'+$(this).data('video')+'&autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>');
		});

		if ( $('#videoCarousel').length ){
			if (window.location.href.match('play')) {
				var click = new URL(window.location.href).searchParams.get("play");
				if (/^\d+$/g.test(click)) {
					$('.section-life-item-'+click).trigger('click').addClass('active');
				}
			}
		}
	});
});

jQuery(function($){
	$('#loadmore').click(function(){

		var button = $(this),
		    data = {
			'action': 'loadmore',
			'query': misha_loadmore_params.posts, // that's how we get params from wp_localize_script() function
			'page' : misha_loadmore_params.current_page
		};

		$.ajax({
			url : misha_loadmore_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {
					button.text( 'More posts' ).prev().before(data); // insert new posts
					misha_loadmore_params.current_page++;

					if ( misha_loadmore_params.current_page == misha_loadmore_params.max_page )
						button.remove(); // if last page, remove the button

					// you can also fire the "post-load" event here if you use a plugin that requires it
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	});
});
